var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconErrorDarkRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_757_5895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66667C14.6025 1.66667 18.3333 5.39751 18.3333 10C18.3351 12.1879 17.4763 14.2887 15.9424 15.8489C14.4085 17.409 12.3226 18.3034 10.135 18.3388C7.94742 18.3743 5.83362 17.548 4.25 16.0383C2.66639 14.5287 1.74 12.4568 1.67084 10.27L1.66667 10L1.67001 9.76667C1.79334 5.27251 5.47501 1.66667 10 1.66667ZM10.0083 12.5L9.90251 12.5058C9.69996 12.5299 9.51329 12.6275 9.37785 12.78C9.24241 12.9325 9.1676 13.1294 9.1676 13.3333C9.1676 13.5373 9.24241 13.7342 9.37785 13.8867C9.51329 14.0392 9.69996 14.1367 9.90251 14.1608L10 14.1667L10.1058 14.1608C10.3084 14.1367 10.4951 14.0392 10.6305 13.8867C10.7659 13.7342 10.8407 13.5373 10.8407 13.3333C10.8407 13.1294 10.7659 12.9325 10.6305 12.78C10.4951 12.6275 10.3084 12.5299 10.1058 12.5058L10.0083 12.5ZM10 5.83334C9.79589 5.83337 9.59889 5.9083 9.44636 6.04393C9.29383 6.17957 9.19639 6.36646 9.17251 6.56917L9.16667 6.66667V10L9.17251 10.0975C9.1966 10.3 9.29414 10.4867 9.44664 10.6222C9.59915 10.7576 9.79604 10.8324 10 10.8324C10.204 10.8324 10.4009 10.7576 10.5534 10.6222C10.7059 10.4867 10.8034 10.3 10.8275 10.0975L10.8333 10V6.66667L10.8275 6.56917C10.8036 6.36646 10.7062 6.17957 10.5536 6.04393C10.4011 5.9083 10.2041 5.83337 10 5.83334Z",
    fill: "#8B0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_757_5895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorDarkRed);
export default __webpack_public_path__ + "static/media/Icon_Error_DarkRed.31e940967c3846770bf0a0981eeefbae.svg";
export { ForwardRef as ReactComponent };